import { z } from 'zod';
import { WORK_UPDATE_LIMITS } from '../constants/projectConstants';

const { TITLE_MIN, TITLE_MAX, DESC_MAX } = WORK_UPDATE_LIMITS;

export const workUpdateSchema = z.object({
  updateStatus: z.string().min(1, 'Select a status'),
  title: z.preprocess(
    (v) => (typeof v === 'string' ? v.trim() : ''),
    z
      .string()
      .min(TITLE_MIN, `Update title must be at least ${TITLE_MIN} characters`)
      .max(TITLE_MAX, `Update title must be at most ${TITLE_MAX} characters`)
  ),
  description: z.preprocess(
    (v) => (v === undefined || v === null ? '' : String(v)),
    z.string().max(DESC_MAX, `Description must be at most ${DESC_MAX} characters`)
  ),
  progress: z.coerce.number().min(0).max(100)
});
